// ./event-handlers/bugsnag.js
let loadCalled = false;
let client = null;

const queued = {
  breadcrumbs: [],
  notify: []
};

let resolveReady;
export const bugsnagReady = new Promise(r => { resolveReady = r; });

function loadBugsnag() {
  if (loadCalled) return;
  loadCalled = true;

  // Defer a bit to avoid competing with UI work (like Fingerprint)
  const start = () => {
	const src = window.__BUGSNAG_SRC__;
	if (!src || !window.__bugsnagConfig) return;

	const s = document.createElement('script');
	s.src = src;
	s.async = true;
	s.onload = () => {
	  try {
		// Support both legacy global "bugsnag" and modern "Bugsnag.start"
		client = window.Bugsnag
		  ? window.Bugsnag.start(window.__bugsnagConfig)
		  : window.bugsnag(window.__bugsnagConfig);

		// Flush anything queued before load
		queued.breadcrumbs.splice(0).forEach(args => client.leaveBreadcrumb(...args));
		queued.notify.splice(0).forEach(args => client.notify(...args));

		resolveReady && resolveReady(client);
	  } catch (e) {
		console.warn('Bugsnag init failed', e);
	  }
	};
	s.onerror = () => console.warn('Failed to load Bugsnag script:', src);
	document.head.appendChild(s);
  };

  if ('requestIdleCallback' in window) {
	requestIdleCallback(start, { timeout: 3000 });
  } else {
	setTimeout(start, 1000);
  }
}

// Safe wrappers to use anywhere
function bugsnagLeaveBreadcrumb(...args) {
  if (client) return client.leaveBreadcrumb(...args);
  queued.breadcrumbs.push(args);
}

function bugsnagNotify(...args) {
  if (client) return client.notify(...args);
  queued.notify.push(args);
}

export {
	loadBugsnag,
	bugsnagLeaveBreadcrumb,
	bugsnagNotify
}